export function extractXmlText(xmlFragment: string): string[] {
    // Wrap to allow multiple root <p> siblings
    const wrapped = `<root>${xmlFragment}</root>`;

    const parser = new DOMParser();
    const doc = parser.parseFromString(wrapped, 'application/xml');

    let results: string[];

    // Guard: parser errors
    if (doc.getElementsByTagName('parsererror').length) {
        // Fallback parse as HTML (some engines are picky about namespaces)
        const htmlDoc = new DOMParser().parseFromString(wrapped, 'text/html');
        results = collectPText(htmlDoc);
    } else {
        results = collectPText(doc);
    }

    if (!results.length || results.every((r) => !r.trim())) {
        return [xmlFragment];
    }

    return results;
}

function collectPText(doc: Document): string[] {
    // Select all elements and filter by localName === 'p' so we ignore namespaces
    const all = Array.from(doc.getElementsByTagName('*'));
    const pEls = all.filter((el) => el.localName?.toLowerCase() === 'p');

    const lines: string[] = [];

    for (const p of pEls) {
        // You can skip specific things here if you add flags:
        // if (p.getAttribute("aria-hidden") === "true") continue;
        // if (p.getAttribute("data-tts") === "ignore") continue;

        // textContent gives the readable text from nested <span>, etc.
        let text = (p.textContent ?? '')
            .replace(/\u00A0/g, ' ') // nbsp -> space
            .replace(/\s+/g, ' ') // collapse whitespace
            .trim();

        text = humanizeMathForTTS(text);

        if (text.length > 0) {
            lines.push(text);
        }
    }

    return lines;
}

function humanizeMathForTTS(line: string): string {
    return line
        .replace(/×/g, ' times ')
        .replace(/÷/g, ' divided by ')
        .replace(/\+/g, ' plus ')
        .replace(/([A-Za-z0-9)\]])\s*[-–—−]\s*(?=[0-9([]|[A-Za-z](?=\d|\())/g, ' minus ')
        .replace(/=/g, ' equals ')
        .replace(/\s+/g, ' ')
        .trim();
}
